import styled from 'styled-components';
import Inner from '../components/Inner';
import PageTitle from '../components/PageTitle';
import ExhibitioinCard from '../components/ExhibitioinCard';
import exhibitions from '../mock/exhibition.json';

const CardContainer = styled.div`
	margin: 7rem 0 13rem;

	@media (max-width: 767px) {
		margin: 4rem 0 8rem;
	}

	@media (min-width: 768px) and (max-width: 1023px) {
		margin: 4.8rem 0 9.8rem;
	}
`;

function Exhibition() {
	return (
		<Inner>
			<PageTitle>Exhibition</PageTitle>
			<CardContainer>
				{exhibitions.map((exhibition, idx) => {
					return (
						<ExhibitioinCard
							key={idx}
							name={exhibition.name}
							title={exhibition.title}
							description={exhibition.description}
							images={exhibition.images}
						/>
					);
				})}
			</CardContainer>
		</Inner>
	);
}

export default Exhibition;
